import { render, staticRenderFns } from "./EditShortcut.vue?vue&type=template&id=d39e321e&scoped=true"
import script from "./EditShortcut.vue?vue&type=script&lang=js"
export * from "./EditShortcut.vue?vue&type=script&lang=js"
import style0 from "./EditShortcut.vue?vue&type=style&index=0&id=d39e321e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39e321e",
  null
  
)

export default component.exports